export default "__VITE_ASSET__i64XEMnv__"